var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Footer.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<footer class=\"Footer\">\n    <div class=\"Footer-col\">\n        <div class=\"Footer-primary\">\n            <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"addressLink"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"address")), env.opts.autoescape);
output += "\n            </a>\n        </div>\n        <div class=\"Footer-secondary\">\n            <p>© 2015 OFFCON Architecture, Planning and Design</p>\n\n            <p> Designed in collaboration with Code and Theory</p>\n        </div>\n    </div>\n    <div class=\"Footer-col\">\n        <div class=\"Footer-primary\">\n            <a href=\"mailto:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
output += "</a>\n            <a href=\"tel:";
output += runtime.suppressValue(env.getFilter("replace").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone")," ",""), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone"), env.opts.autoescape);
output += "</a>\n        </div>\n        <div class=\"Footer-secondary\">\n            Design by <a href=\"https://whiterussianstudio.com\" target=\"_blank\">WRS</a><br/>\n            Developed by <a href=\"https://astroshock.com/\" target=\"_blank\">Astroshock</a>\n        </div>\n    </div>\n    <div class=\"Footer-col socialIconsCol\">\n        <div class=\"Footer-primary socialIconsContainer\">\n            <a class=\"socialIcon linkedin\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"linkedinLink"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                <svg viewBox=\"0 0 72 72\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"\n                          d=\"M8 72H64C68.4183 72 72 68.4183 72 64V8C72 3.58172 68.4183 0 64 0H8C3.58172 0 0 3.58172 0 8V64C0 68.4183 3.58172 72 8 72Z\"/>\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"\n                          d=\"M62 62H51.3156V43.8021C51.3156 38.8128 49.4198 36.0245 45.4707 36.0245C41.1746 36.0245 38.9301 38.9261 38.9301 43.8021V62H28.6333V27.3333H38.9301V32.0029C38.9301 32.0029 42.026 26.2742 49.3826 26.2742C56.7357 26.2742 62 30.7645 62 40.0512V62ZM16.3493 22.794C12.8421 22.794 10 19.9297 10 16.397C10 12.8644 12.8421 10 16.3493 10C19.8566 10 22.697 12.8644 22.697 16.397C22.697 19.9297 19.8566 22.794 16.3493 22.794ZM11.0326 62H21.7694V27.3333H11.0326V62Z\"/>\n                </svg>\n            </a>\n        </div>\n    </div>\n</footer>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Footer.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Footer/Footer.jinja
// module id = 33
// module chunks = 0